// #348: um módulo só pode compor um perfil se estiver liberado em TODAS as
// gerências onde aquele perfil vale. Escopo vazio significa "vale em todas as
// gerências" (#350), e aí o alvo passa a ser toda gerência que tem efetivo.
//
// Este predicado decide só o que a TELA oferece. A recusa de verdade é do
// servidor (`funcionalidadesForaDoEscopo`), porque regra que só existe na tela
// é contornável por POST direto — foi o que aconteceu com `perfil.ativo`.
//
// A regra existe dos dois lados e não há como compartilhar código entre
// `virgem/` e `SEGOV/`. O que impede as duas cópias de divergirem é cada uma
// ter teste próprio sobre os mesmos casos de borda.
export default function moduloValeNoEscopo(
  modulo,
  escopo,
  gerenciasComEfetivo
) {
  const liberadoEm = Array.isArray(modulo && modulo.gerencias)
    ? modulo.gerencias
    : [];

  const doEscopo = Array.isArray(escopo) ? escopo : [];
  const comEfetivo = Array.isArray(gerenciasComEfetivo)
    ? gerenciasComEfetivo
    : [];

  const alvo = doEscopo.length > 0 ? doEscopo : comEfetivo;
  // Sem nada contra o que checar, liberar é a única resposta honesta — recusar
  // travaria a tela num banco sem efetivo cadastrado.
  if (alvo.length === 0) return true;

  const conjunto = new Set(liberadoEm.map(Number));
  return alvo.every(g => conjunto.has(Number(g)));
}
